import React, { ComponentProps } from 'react'

type XIconProps = ComponentProps<'svg'> & {
    iconColor?: string
}

export const XIcon = ({ iconColor = '#8A9BA8', ...props }: XIconProps) => {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M1.5 10.5L10.5 1.5M1.5 1.5L10.5 10.5"
                stroke={iconColor}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
